(function () {
  function cur() {
    var i = document.querySelector('form.pf-product-form [name="id"]')
         || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return i && i.value ? i.value : null;
  }
  function fix(url) {
    try {
      var id = cur(); if (!id) return url;
      var u = new URL(url || location.href, location.origin);
      if (!/\/products\//.test(u.pathname)) return url;
      if (u.searchParams.get('variant') === id) return url;
      u.searchParams.set('variant', id);
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  }
  ['pushState', 'replaceState'].forEach(function (m) {
    var o = history[m].bind(history);
    history[m] = function (a, b, url) { return o(a, b, fix(url)); };
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.pf-option-swatches, .pf-vs-radio')) {
      [200, 600, 1200].forEach(function (d) {
        setTimeout(function () {
          var id = cur(); if (!id) return;
          var u = new URL(location.href);
          if (u.searchParams.get('variant') !== id) {
            u.searchParams.set('variant', id);
            history.replaceState({}, '', u.pathname + u.search + u.hash);
          }
        }, d);
      });
    }
  }, true);
})();

(function () {
  var swatchEl = document.querySelector('[data-pf-type="ProductVariantSwatches"][data-product-id]');
  if (!swatchEl) return;

  var productId = swatchEl.getAttribute('data-product-id');
  var hiddenInput = document.querySelector('input[type="hidden"][name="id"][data-product-id="' + productId + '"]');
  if (!hiddenInput) return;

  // Watch hidden input value change (PageFly sets via setAttribute)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'value') {
        syncAppstlePrices(hiddenInput.value);
      }
    }
  });
  observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });

  function syncAppstlePrices(variantId) {
    var product = window.__pageflyProducts && window.__pageflyProducts[productId];
    if (!product) return;

    var variant = product.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;

    // 1) Update one-time purchase price
    updateText('.appstle_one_time_price_wrapper .appstle_subscription_amount:not(.sr-only)', formatPrice(variant.price));
    updateText('.appstle_one_time_price_wrapper .appstle_subscription_amount-appstle-sr-only', 'Sale price ' + formatPrice(variant.price));

    if (variant.compare_at_price) {
      updateText('.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price:not(.sr-only)', formatPrice(variant.compare_at_price));
      updateText('.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price-appstle-sr-only', 'Original price ' + formatPrice(variant.compare_at_price));
    }

    // 2) Update subscription prices
    updateSubscriptionPrices(variant);
  }

  function updateSubscriptionPrices(variant) {
    if (!variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return;

    var selectEl = document.getElementById('appstle_selling_plan0');
    var selectedPlanId = selectEl ? selectEl.value : null;

    var allocation = variant.selling_plan_allocations.find(function (a) {
      return String(a.selling_plan_id) === String(selectedPlanId);
    }) || variant.selling_plan_allocations[0];

    // Subscription price
    updateText('.appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_subscription_amount:not(.sr-only)', formatPrice(allocation.price));
    updateText('.appstle_subscription_wrapper_option.appstle_include_dropdown .appstle_subscription_amount-appstle-sr-only', 'Sale price ' + formatPrice(allocation.price));

    // Compare at price
    updateText('.appstle_subscription_compare_amount:not(.sr-only)', formatPrice(allocation.compare_at_price));
    updateText('.appstle_subscription_compare_amount-appstle-sr-only', 'Original price ' + formatPrice(allocation.compare_at_price));

    // Update Appstle hidden input
    var appstleInput = document.querySelector('input.appstle-selectedSellingPlan');
    if (appstleInput) appstleInput.value = allocation.selling_plan_id;

    // Update widget data attribute
    var widget = document.querySelector('[id^="appstle_subscription_widget"]');
    if (widget) widget.setAttribute('data-selected-selling-plan', allocation.selling_plan_id);
  }

  // Also sync when selling plan dropdown changes
  var planSelect = document.getElementById('appstle_selling_plan0');
  if (planSelect) {
    planSelect.addEventListener('change', function () {
      syncAppstlePrices(hiddenInput.value);
    });
  }

  function updateText(selector, text) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.textContent = text;
    });
  }

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
})();
